import _ from 'lodash'

export default {
  deepcopy (objToCopy) {
    return _.cloneDeep(objToCopy)
  },
  getErrorMessage(ex, compStatus, retMessage) {

    let message
    let err
    let status
    if (ex.response && ex.response.data) {
      const data = ex.response.data
      message = data.message || data.detail || (typeof data === 'string' ? data : null)
      err = data.error || data.title
      status = '(' + (data.status || ex.response.status) + ')'
    }

    if (!message) {
      message = ex.message
    }

    if (!err && ex.response) {
      err = ex.response.statusText
    }

    if (!status && ex.response) {
      status = '(' + ex.response.status + ')'
    }

    if (compStatus && (status === ('(' + compStatus + ')'))) {
      return retMessage
    }

    if (status === '(401)') {
      return "Invalid credentials"
    }

    if (status === '(409)') {
      return "A resource conflict occurred. Please reload page and try again."
    }

    return [status, err, message && err !== message ? message : null].filter(Boolean).join(' ')
  },
  getValidationResult(response) {
    console.log("Validation response:")

    const data = response.data

    console.dir(data)

    if (response.status === 200) {
        if (_.isEmpty(data)) {
            return {success: false, message: "An invalid response was received. The collector may not have a suitable driver for validation."}
        } else {
            const colKeys = _.keys(data)
            const colValues = _.values(data)
            const anyFailures = _.find(colValues, { "_success": false })

            let errMsgs = [];
            let errorCount = 0;
            let dispMsgs = [];
            _.each(colKeys, (key) => {
                const msgObj = data[key].errorMessages
                errMsgs.push(key + ": " + _.values(msgObj).join())
                if (!data[key]["_success"]) {
                    errorCount++;
                    dispMsgs.push(_.pull(_.values(data[key].displayMessages), null).join())
                }
            })

            if (!anyFailures) {
              return {success: true, messages: errMsgs}    
            }

            let message = (_.uniq(dispMsgs)).join()
            console.log(message)
            if (!message) {
              if (errorCount === 1) {
                  message = errorCount + " error encountered"
              } else {
                  message = errorCount + " errors encountered"
              }
            }
            return {success: false, messages: errMsgs, message}

        }
    } else {
        const message = response.exception ? response.exception.message : response.statusText
        return {success: false, message}
    }
  }
}